var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import ServiceEntriesControls from './ServiceEntriesControls';
import ServiceEntriesRow from './ServiceEntriesRow';
import { EmptyDivRow } from '../../components/ui/EmptyRow/EmptyRow';
import GetOpenServiceEntriesCommand from '../../../commands/services/GetOpenServiceEntriesCommand';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import { ApplicationContext } from '../../../ApplicationContext';
import GetOrganisationAssetsCommand from '../../../commands/assets/GetOrganisationAssetsCommand';
import ServiceEntriesViewState from '../../../data/ServiceEntriesViewState';
import Signals from '../../../signals/Signals';
import { getHashParams } from '../../../utils/urlUtils';
import ServiceEntriesSignals from './signals/ServiceEntriesSignals';
import TableSettingsOverlay from "../../components/ui/TableSettingsOverlay/TableSettingsOverlay";
import TableModel from "../../../models/TableModel";
import Page from "../Page";
/**
 *
 */
var ServiceEntries = /** @class */ (function (_super) {
    __extends(ServiceEntries, _super);
    /**
     *
     * @param props
     */
    function ServiceEntries(props) {
        var _this = _super.call(this, props) || this;
        _this.setTableRef = _this.setTableRef.bind(_this);
        _this.onTableScroll = _this.onTableScroll.bind(_this);
        _this.onSortClick = _this.onSortClick.bind(_this);
        _this.onHashChange = _this.onHashChange.bind(_this);
        _this.onServiceEntryClosed = _this.onServiceEntryClosed.bind(_this);
        _this.onServiceEntryUpdated = _this.onServiceEntryUpdated.bind(_this);
        _this.onServiceEntryAdded = _this.onServiceEntryAdded.bind(_this);
        _this.updateHash = _this.updateHash.bind(_this);
        _this.updateLabels = _this.updateLabels.bind(_this);
        _this.state = {
            viewState: ServiceEntriesViewState.TABLE,
            tableModel: new TableModel()
        };
        return _this;
    }
    /**
     *
     */
    ServiceEntries.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.context, serviceEntryCollection = _a.serviceEntryCollection, assetCollection = _a.assetCollection, session = _a.session;
        var intl = this.props.intl;
        var openServiceEntriesCommand = new GetOpenServiceEntriesCommand().execute(session.user.organisation, serviceEntryCollection);
        var organisationAssetsCommand = new GetOrganisationAssetsCommand().execute(session.user.organisation, assetCollection);
        // Update labels every time new data comes in, and at the start, since they might have been changed
        openServiceEntriesCommand.then(function () { return _this.updateLabels(); });
        organisationAssetsCommand.then(function () { return _this.updateLabels(); });
        this.updateLabels();
        Promise.all([openServiceEntriesCommand, organisationAssetsCommand]).then(function () {
            // Force map positioning
            serviceEntryCollection.update();
            ServiceEntriesSignals.zoomOut.dispatch();
        }).catch(function () {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "serviceentry.error.getopenserviceentries" }), 'danger', true);
        });
        //
        Signals.ChangeServiceEntriesViewState.add(function (state) {
            _this.setState({ viewState: state }, function () { return _this.updateHash(); });
        });
        //
        Signals.ServiceEntryClosed.add(this.onServiceEntryClosed);
        Signals.ServiceEntryUpdated.add(this.onServiceEntryUpdated);
        Signals.ServiceEntryAdded.add(this.onServiceEntryAdded);
        Signals.RefreshAssets.add(function () { return _this.updateLabels; });
        Signals.AssetsRetrieved.add(function () { return _this.updateLabels; });
        //
        Signals.HashChanged.add(this.onHashChange);
        this.onHashChange();
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ServiceEntries.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.state, table = _a.table, tableContainer = _a.tableContainer;
        if (table) {
            if (tableContainer.scrollTop > table.offsetHeight) {
                table.scrollIntoView();
            }
        }
    };
    /**
     *
     */
    ServiceEntries.prototype.componentWillUnmount = function () {
        Signals.HashChanged.remove(this.onHashChange);
        Signals.ServiceEntryClosed.remove(this.onServiceEntryClosed);
        Signals.ServiceEntryUpdated.remove(this.onServiceEntryUpdated);
        Signals.ServiceEntryAdded.remove(this.onServiceEntryAdded);
        Signals.ChangeServiceEntriesViewState.removeAll();
        ServiceEntriesSignals.filtersChanged.removeAll();
        Signals.RefreshAssets.remove(this.updateLabels);
        Signals.AssetsRetrieved.remove(this.updateLabels);
    };
    /**
     *
     */
    ServiceEntries.prototype.render = function () {
        var intl = this.props.intl;
        var _a = this.context, serviceEntryCollection = _a.serviceEntryCollection, session = _a.session;
        var _b = this.state, viewState = _b.viewState, tableModel = _b.tableModel;
        return React.createElement(Page, { pageName: "service-entries" },
            React.createElement("div", { className: "h-100 pb-4" },
                React.createElement("div", { className: "card mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement("div", { className: "card-header align-items-start flex-grow-0 pb-0" },
                        React.createElement("div", { className: "d-flex justify-content-between mb-4 pr-3 flex-wrap" },
                            React.createElement("h1", { className: 'header-title align-self-center order-0 mr-3' },
                                React.createElement(FormattedMessage, { id: "page.service.entries.title" }))),
                        React.createElement("div", { className: "d-flex flex-nowrap button-grid justify-content-end align-items-start flex-fill" },
                            React.createElement(ServiceEntriesControls, { serviceEntryCollection: serviceEntryCollection },
                                React.createElement("div", { className: "nav btn-group dropdown", role: "group" },
                                    React.createElement("button", { className: "btn btn-white dropdown-toggle", type: "button", id: "exportFileButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                                        React.createElement("div", { className: "d-none d-md-inline" },
                                            React.createElement(FormattedMessage, { id: "label.export", defaultMessage: "Export" })),
                                        React.createElement("span", { className: "d-md-none fe fe-download" })),
                                    React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "exportFileButton" },
                                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function () {
                                                serviceEntryCollection.export('xlsx', intl);
                                            } },
                                            React.createElement("span", null, "xlsx")),
                                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function () {
                                                serviceEntryCollection.export('csv', intl);
                                            } },
                                            React.createElement("span", null, "csv")))),
                                tableModel ?
                                    React.createElement("div", { className: "nav btn-group h-100" },
                                        React.createElement("button", { className: "btn btn-white", type: "button", id: "tableSettings", onClick: function () {
                                                Signals.ShowOverlay.dispatch(React.createElement(TableSettingsOverlay, { tableModel: tableModel }));
                                            } },
                                            React.createElement("span", { className: "fe fe-settings" }))) : null))),
                    React.createElement("div", { className: "card-body pt-0 mr-4 pr-0 overflow-auto" },
                        React.createElement("div", { ref: this.setTableRef, className: "table-container w-100 h-100 flex-fill" },
                            React.createElement("div", { className: "" },
                                React.createElement("div", { className: "w-100", style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
                                        rowGap: "1.3rem",
                                        minWidth: "fit-content"
                                    } },
                                    React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "calculatedStatus" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.status" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "equipmentId" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.assetid" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "place" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.location" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "labelSortString" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.labels" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "name" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.name" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "description" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.description" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "priority" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.priority" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "originatingTriggerValue.all" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.originatingtriggervalue.all" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "cumulativeOperatingHoursDurationInHours" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.operatinghours" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "assignedTo" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.assignedto" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "operatorName" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.operator" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "creationDateTimeUtc" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.created" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "scheduledDateTimeUtc" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.scheduled" })),
                                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "dueDateTimeUtc" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.due" })),
                                        React.createElement("div", null)),
                                    serviceEntryCollection.filtered.length > 0 ?
                                        serviceEntryCollection.filteredAndSorted.map(function (serviceEntryModel, index) {
                                            return React.createElement(ServiceEntriesRow, { key: index + '-' + serviceEntryModel.serviceEntryId, serviceEntryModel: serviceEntryModel, compact: tableModel.compact });
                                        }) : React.createElement(EmptyDivRow, null))),
                            React.createElement("div", { className: "d-flex justify-content-center my-4" },
                                React.createElement(Link, { to: Routes.SERVICE_ENTRIES_CLOSED.path },
                                    React.createElement("button", { className: "btn btn-sm btn-outline-primary" },
                                        React.createElement("i", { className: "fe fe-archive" }),
                                        " ",
                                        React.createElement(FormattedMessage, { id: "page.closed.service.entries.title" })))))))));
    };
    /**
     *
     * @param event
     */
    ServiceEntries.prototype.onSortClick = function (event) {
        var serviceEntryCollection = this.context.serviceEntryCollection;
        var sort = serviceEntryCollection.sort;
        var fieldName = event.target.dataset.sortby;
        var direction = sort.fieldName === fieldName ? sort.direction * -1 : 1;
        serviceEntryCollection.sort.update({ fieldName: event.target.dataset.sortby, direction: direction });
        serviceEntryCollection.updateSortCache();
    };
    /**
     *
     */
    ServiceEntries.prototype.onTableScroll = function () {
        var _a = this.state, thead = _a.thead, tableContainer = _a.tableContainer;
        thead.style.transform = 'translateY(' + tableContainer.scrollTop + 'px)';
        if (tableContainer.scrollTop < 5 && thead.classList.contains('box-shadow')) {
            thead.classList.remove('box-shadow');
        }
        if (tableContainer.scrollTop > 5 && !thead.classList.contains('box-shadow')) {
            thead.classList.add('box-shadow');
        }
    };
    /**
     *
     */
    ServiceEntries.prototype.onHashChange = function () {
        var hashParams = getHashParams();
        // Apply view state
        if (hashParams.view) {
            if (hashParams.view === ServiceEntriesViewState.MAP) {
                this.setState({ viewState: ServiceEntriesViewState.MAP });
            }
            if (hashParams.view === ServiceEntriesViewState.TABLE) {
                this.setState({ viewState: ServiceEntriesViewState.TABLE });
            }
        }
    };
    /**
     *
     * @param serviceEntryModel
     */
    ServiceEntries.prototype.onServiceEntryClosed = function (serviceEntryModel) {
        var serviceEntryCollection = this.context.serviceEntryCollection;
        var model = serviceEntryCollection.find('serviceEntryId', serviceEntryModel.serviceEntryId);
        serviceEntryCollection.remove(model);
    };
    /**
     *
     * @param serviceEntryModel
     */
    ServiceEntries.prototype.onServiceEntryUpdated = function (serviceEntryModel) {
        var serviceEntryCollection = this.context.serviceEntryCollection;
        var model = serviceEntryCollection.find('serviceEntryId', serviceEntryModel.serviceEntryId);
        if (model) {
            model.update(serviceEntryModel);
        }
        this.forceUpdate();
    };
    /**
     *
     */
    ServiceEntries.prototype.onServiceEntryAdded = function (serviceEntryModel) {
        var serviceEntryCollection = this.context.serviceEntryCollection;
        serviceEntryCollection.add(serviceEntryModel);
        this.updateLabels();
    };
    /**
     *
     */
    ServiceEntries.prototype.updateLabels = function () {
        var _a = this.context, serviceEntryCollection = _a.serviceEntryCollection, assetCollection = _a.assetCollection;
        serviceEntryCollection.list.forEach(function (serviceEntryModel) {
            serviceEntryModel.assetModel = assetCollection.list.find(function (asset) {
                return asset.getAssetSerial() === serviceEntryModel.assetId;
            });
            serviceEntryModel.calculatedStatus; // use to set serviceStatus property on assetModel
            serviceEntryModel.labels = serviceEntryModel.assetModel ? serviceEntryModel.assetModel.labels.concat([]) : [];
        });
        serviceEntryCollection.update();
    };
    /**
     *
     * @param ref
     */
    ServiceEntries.prototype.setTableRef = function (ref) {
        if (ref) {
            var table = ref.querySelector('table');
            var thead = ref.querySelector('thead');
            this.setState({ table: table, thead: thead, tableContainer: ref });
            ref.addEventListener('scroll', this.onTableScroll);
        }
    };
    /**
     *
     */
    ServiceEntries.prototype.updateHash = function () {
        var viewState = this.state.viewState;
        history.pushState(null, null, '#view=' + viewState);
    };
    ServiceEntries.defaultProps = {
        className: ''
    };
    ServiceEntries = __decorate([
        observer
    ], ServiceEntries);
    return ServiceEntries;
}(React.Component));
ServiceEntries.contextType = ApplicationContext;
export default injectIntl(ServiceEntries);
